import React, { useEffect } from "react";
import {
  casinoBallByBallBetAPI,
  getBallByBallOddsAPI,
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
} from "../../service/casino";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";
import loadash from "lodash";
import PlaceBetUniversal from "../universalCasino/PlaceBetUniversal";
import toast from "react-hot-toast";
import {
  getUniversalCasinoBallByBallPlExposureByRunner,
  getUniversalCasinoPlExposureByRunner,
} from "../universalCasino/genericFunctions";
export default function BallByBall() {
  const [data, setData] = React.useState(null);
  const getBallByBallData = async () => {
    const { response } = await getBallByBallOddsAPI();
    setData(response);
  };
  useEffect(() => {
    getBallByBallData();
    let interval = setInterval(() => {
      getBallByBallData();
    }, 500);
    return () => clearInterval(interval);
  }, []);
  const roundIdRef = React.useRef(null);
  const [exposure, setExposure] = React.useState(null);
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    if (data && data?.markets && data?.markets[0]?.marketId) {
      roundIdRef.current = data?.markets[0]?.marketId;
      getExposure();
      let interval = setInterval(() => {
        getExposure();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [data?.markets?.length]);
  const [selectedResultToShow, setSelectedResultToShow] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const colorMapping = {
    "0 RUNS": "back-1",
    "1 RUNS": "back-1",
    "2 RUNS": "back-1",
    "3 RUNS": "back-1",
    "4 RUNS": "back-4",
    "6 RUNS": "back-6",
    WICKET: "back-wicket",
    "EXTRA RUNS": "back-1",
  };
  const [placeBetPayload, setPlaceBetPayload] = React.useState({});
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await casinoBallByBallBetAPI(
      placeBetPayload
    );
    if (code === 200) {
      toast.success(status);
      getBallByBallData();
      setPlaceBetPayload(null);
    } else {
      toast.error(response);
    }
    setLoading(false);
  };
  const placeBet = async (marketIdWithSelectionId, runnerName, back, index) => {
    let payload = { ...placeBetPayload, index };
    payload.marketIdWithSelectionId = `${marketIdWithSelectionId}`;
    payload.ballByBallSelectionId = marketIdWithSelectionId.split(":")[1];
    payload.runnerName = runnerName;
    payload.back = back;
    payload.marketId = data?.markets[0]?.marketId;
    payload.eventId = data?.markets[0]?.eventId;
    payload.amount = 100;
    payload.type = "back";
    payload.casinoGames = "UNI_BALL_BY_BALL";
    setPlaceBetPayload(payload);
  };
  const [lastTenResults, setLastTenResults] = React.useState([]);
  const getLastTenResults = async (id) => {
    const { response, code } = await getUniversalCasinoLastResultAPI(
      "UNI_BALL_BY_BALL",
      id
    );
    if (code == 200) {
      let data_ = response?.data;
      setLastTenResults(data_);
    }
  };
  useEffect(() => {
    if (data && data?.markets && data?.markets[0]?.eventId) {
      getLastTenResults(data?.markets[0]?.eventId);
      let interval = setInterval(() => {
        getLastTenResults(data?.markets[0]?.eventId);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [data?.markets?.length]);

  return (
    <div
      _ngcontent-ng-c2192290883=""
      className="d-flex app-body adjust-height-100"
    >
      <div
        _ngcontent-ng-c2192290883=""
        className="sidebar showDesktop hideDekstop"
      >
        <app-side-bar _ngcontent-ng-c2192290883="" _nghost-ng-c1362099036="">
          <div _ngcontent-ng-c1362099036="" className="sidebar">
            <nav
              _ngcontent-ng-c1362099036=""
              className="sidebar-nav ps ps--active-y apply-scroll"
              style={{ width: "99.8%" }}
            >
              <div _ngcontent-ng-c1362099036="" className="top-head-sport">
                <ul _ngcontent-ng-c1362099036="" className="text-right mr-2">
                  <li _ngcontent-ng-c1362099036="">
                    <a _ngcontent-ng-c1362099036="" className="path-back">
                      <i
                        _ngcontent-ng-c1362099036=""
                        aria-hidden="true"
                        className="fa fa-ellipsis-v"
                        style={{ fontSize: 14 }}
                      />
                    </a>
                  </li>
                  <li _ngcontent-ng-c1362099036="">
                    <a
                      _ngcontent-ng-c1362099036=""
                      style={{ position: "relative", top: "1.5px" }}
                    >
                      Sports
                    </a>
                  </li>
                </ul>
              </div>
              <div _ngcontent-ng-c1362099036="" className="scrollNav">
                <ul _ngcontent-ng-c1362099036="" className="nav">
                  {/**/}
                  <div
                    _ngcontent-ng-c1362099036=""
                    className="sideW ng-star-inserted"
                  >
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Cricket</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Casino</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Tennis</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Soccer</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Horse Racing</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">
                          Greyhound Racing
                        </span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Basketball</span>
                      </a>
                    </li>
                    <li
                      _ngcontent-ng-c1362099036=""
                      className="nav-item nav-dropdown ng-star-inserted"
                    >
                      <a
                        _ngcontent-ng-c1362099036=""
                        href="javascript:;"
                        className="nav-link nav-dropdown-toggle"
                      >
                        <span _ngcontent-ng-c1362099036="">Lottery</span>
                      </a>
                    </li>
                    {/**/}
                  </div>
                  {/**/}
                </ul>
              </div>
              <div
                _ngcontent-ng-c1362099036=""
                className="ps__rail-y"
                style={{ top: 0, height: 403, right: 0 }}
              >
                <div
                  _ngcontent-ng-c1362099036=""
                  tabIndex={0}
                  className="ps__thumb-y"
                  style={{ top: 0, height: 379 }}
                />
              </div>
            </nav>
          </div>
        </app-side-bar>
      </div>
      <div
        style={{
          marginTop: "0px",
        }}
        _ngcontent-ng-c2192290883=""
        className="content"
      >
        <router-outlet _ngcontent-ng-c2192290883="" />
        {data && data?.markets?.length > 0 && (
          <app-ballbyball
            _nghost-ng-c3233251477=""
            className="ng-star-inserted"
          >
            {/**/}
            <div
              _ngcontent-ng-c3233251477=""
              className="position-relative mobileScoreCardAndStream"
            >
              <div _ngcontent-ng-c3233251477="" className="game-highlight-wrap">
                <span
                  _ngcontent-ng-c3233251477=""
                  className="cric-txt ng-star-inserted"
                >
                  BALL BY BALL
                </span>
                {/**/}
                <span _ngcontent-ng-c3233251477="" className="roundId">
                  {" "}
                  {data?.markets[0]?.marketId}{" "}
                </span>
              </div>
              <div
                _ngcontent-ng-c3233251477=""
                id="tabs"
                className="accordion-body ng-star-inserted"
              >
                <app-video-ballby-ball
                  _ngcontent-ng-c3233251477=""
                  _nghost-ng-c2676723629=""
                >
                  <div _ngcontent-ng-c2676723629="" className="videoPlayer">
                    {data?.markets[0]?.videoUrl?.split("}")[1] && (
                      <video
                        _ngcontent-ng-c2676723629=""
                        id="videoBallByball"
                        width="100%"
                        autoPlay
                        playsInline
                        muted
                        className="isDesktop ng-star-inserted"
                        style={{
                          backgroundColor: "black",
                          backgroundSize: "contain",
                        }}
                      >
                        <source
                          _ngcontent-ng-c2676723629=""
                          type="video/mp4"
                          src={`https://uniique444.com${
                            data?.markets[0]?.videoUrl?.split("}")[1]
                          }`}
                        />{" "}
                        Your browser does not support the video tag.{" "}
                      </video>
                    )}

                    {/**/}
                    {/**/}
                    {!data?.markets[0]?.videoUrl?.split("}")[1] && (
                      <img
                        _ngcontent-ng-c2676723629=""
                        src="https://uniique444.com/assets/ballbyball.gif"
                        alt="Ball by Ball"
                        className="isDesktop ballbyballPoster ng-star-inserted"
                      />
                    )}

                    {data?.markets[0]?.result &&
                      data?.roundStatus == "MARKET_RESULT" && (
                        <div
                          _ngcontent-ng-c2676723629=""
                          className="ballbyballResult ng-star-inserted"
                        >
                          <img
                            _ngcontent-ng-c2676723629=""
                            src={"https://uniique444.com/assets/emptyBall.png"}
                          />
                          <span _ngcontent-ng-c2676723629="">
                            {" "}
                            {data?.markets[0]?.result}{" "}
                          </span>
                          <span
                            _ngcontent-ng-c2676723629=""
                            style={{ position: "absolute" }}
                            className="ng-star-inserted"
                          >
                            <canvas
                              _ngcontent-ng-c2676723629=""
                              width="100vw"
                              height="100vh"
                            />
                          </span>
                          {/**/}
                        </div>
                      )}
                    {/**/}
                    <div _ngcontent-ng-c2676723629="" className="timer-overlay">
                      <GenericCasinoTimer
                        black={true}
                        time={parseInt(data?.seconds)}
                        status={data?.status}
                      />
                    </div>
                  </div>
                </app-video-ballby-ball>
              </div>
              {/**/}
            </div>
            <div
              _ngcontent-ng-c3233251477=""
              id="marketScroll"
              className="overflow-hidden"
            >
              <div
                _ngcontent-ng-c3233251477=""
                className="game-market market-6 ng-star-inserted"
              >
                <div _ngcontent-ng-c3233251477="" className="market-title">
                  <div _ngcontent-ng-c3233251477=""> Runs </div>
                  <div
                    _ngcontent-ng-c3233251477=""
                    className="position-relative"
                  >
                    <div _ngcontent-ng-c3233251477="" className="minMaxDesktop">
                      <span _ngcontent-ng-c3233251477="">
                        Min/Max: 100 - 100000{" "}
                      </span>
                    </div>
                    <span _ngcontent-ng-c3233251477="" className="minMaxMobile">
                      <i
                        _ngcontent-ng-c3233251477=""
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className="fa fa-info-circle ml-2"
                        data-bs-target="#collapse121"
                        id="#collapse123664112025923182042758"
                      />
                      <ul
                        _ngcontent-ng-c3233251477=""
                        className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                        aria-labelledby="collapse123664112025923182042758"
                      >
                        <span _ngcontent-ng-c3233251477="">
                          Min/Max: 100 - 100000{" "}
                        </span>
                      </ul>
                    </span>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c3233251477=""
                  className="market-header row ms-0 me-0"
                >
                  <div
                    _ngcontent-ng-c3233251477=""
                    className="col-6 border-r-transparent paddingZero"
                  >
                    <div
                      _ngcontent-ng-c3233251477=""
                      className="market-row justify-content-center"
                    >
                      <div
                        _ngcontent-ng-c3233251477=""
                        className="market-odd-box back-0"
                      >
                        <b _ngcontent-ng-c3233251477="">Back</b>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c3233251477=""
                    className="col-6 paddingZero"
                  >
                    <div
                      _ngcontent-ng-c3233251477=""
                      className="market-row justify-content-center"
                    >
                      <div
                        _ngcontent-ng-c3233251477=""
                        className="market-odd-box back-0"
                      >
                        <b _ngcontent-ng-c3233251477="">Back</b>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c3233251477=""
                    className="fancy-min-max-box"
                  />
                </div>
                <div _ngcontent-ng-c3233251477="" className="market-body">
                  {loadash
                    .chunk(data?.markets[0]?.oddDetailsDTO, 2)
                    ?.map((market, index) => (
                      <div
                        _ngcontent-ng-c3233251477=""
                        className="row ms-0 me-0"
                        style={{ paddingTop: 8 }}
                      >
                        {market?.map((item, _) => (
                          <div
                            _ngcontent-ng-c3233251477=""
                            className="col-6 d-flex justify-content-center border-r-grey paddingZero"
                          >
                            <div
                              _ngcontent-ng-c3233251477=""
                              data-title="OPEN"
                              className="fancy-market"
                            >
                              <div
                                _ngcontent-ng-c3233251477=""
                                className="market-row"
                              >
                                <div
                                  _ngcontent-ng-c3233251477=""
                                  className="blb-box"
                                >
                                  <a
                                    onClick={() => {
                                      placeBet(
                                        `${data?.markets[0]?.marketId}:${item?.selectionId}`,
                                        item?.runnerName,
                                        item?.back1,
                                        index
                                      );
                                    }}
                                    _ngcontent-ng-c3233251477=""
                                    appratehighlight=""
                                    className={`market-odd-box ${
                                      colorMapping[item?.runnerName]
                                    } ${item?.status?.toLowerCase()}`}
                                  >
                                    <div
                                      _ngcontent-ng-c3233251477=""
                                      className="d-flex flex-column align-items-center"
                                      style={{ width: "40%" }}
                                    >
                                      <span
                                        _ngcontent-ng-c3233251477=""
                                        className="market-odd"
                                      >
                                        {item?.back1}
                                      </span>
                                      <span
                                        _ngcontent-ng-c3233251477=""
                                        className="market-volume"
                                      >
                                        {item?.backSize1}
                                      </span>
                                    </div>
                                    <div
                                      _ngcontent-ng-c3233251477=""
                                      className="position-relative pl-market"
                                    >
                                      <span
                                        _ngcontent-ng-c3233251477=""
                                        className="market-nation-name pointer"
                                        style={{
                                          fontWeight: 800,
                                          paddingLeft: 15,
                                          position: "relative",
                                          fontSize:
                                            item?.runnerName == "EXTRA RUNS"
                                              ? 10
                                              : 14,
                                        }}
                                      >
                                        {item?.runnerName}
                                      </span>
                                      <span
                                        _ngcontent-ng-c3233251477=""
                                        className="d-flex align-items-center justify-content-center position-absolute"
                                        style={{
                                          bottom: 4,
                                          left: "50%",
                                          transform: "translateX(-50%)",
                                        }}
                                      >
                                        <span
                                          _ngcontent-ng-c3233251477=""
                                          className="p-0 ng-star-inserted"
                                          style={{
                                            display: "flex",
                                            fontSize: "11px !important",
                                            fontWeight: 400,
                                          }}
                                        >
                                          <span
                                            _ngcontent-ng-c3233251477=""
                                            className="d-flex"
                                          >
                                            <span
                                              _ngcontent-ng-c3233251477=""
                                              className="plus-book ng-star-inserted"
                                            >
                                              {getUniversalCasinoBallByBallPlExposureByRunner(
                                                exposure,
                                                item?.runnerName,
                                                item?.selectionId,
                                                data?.markets[0]?.marketId
                                              )}
                                            </span>
                                            {/**/}&nbsp; {/**/}
                                          </span>
                                        </span>
                                        {/**/}
                                      </span>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {placeBetPayload && placeBetPayload?.index == index && (
                          <PlaceBetUniversal
                            placeBetPayload={placeBetPayload}
                            setPlaceBetPayload={setPlaceBetPayload}
                            placeBet={placeBetCallApi}
                          />
                        )}
                        {/**/}
                      </div>
                    ))}
                </div>
              </div>
              <div
                _ngcontent-ng-c3233251477=""
                className="text-right progress-bar ng-star-inserted"
              >
                {data&&data?.markets&&<marquee
                  _ngcontent-ng-c3233251477=""
                  direction="left"
                  scrollamount={3}
                  behavior="scroll"
                  className="pull-right progress-bar-txt"
                >
                  {" "}
                  {data?.markets[0]?.news}{" "}
                </marquee>}
              </div>
              <app-results
                _ngcontent-ng-c3233251477=""
                _nghost-ng-c4176941694=""
                className="ng-star-inserted"
              >
                <div
                  _ngcontent-ng-c4176941694=""
                  className="recent-res teenpatti"
                >
                  <h5
                    _ngcontent-ng-c4176941694=""
                    style={{ fontWeight: "bold" }}
                  >
                    Recent Result
                  </h5>
                  <ul _ngcontent-ng-c4176941694="" className="result">
                    {lastTenResults?.map((result) => (
                      <li
                        onClick={() => {
                          setSelectedResultToShow(result);
                        }}
                        _ngcontent-ng-c4176941694=""
                        className={`casino-a sportsbookTile back-${
                          result?.result[0] == "W"
                            ? "wicket"
                            : result?.result[0] == "0" ||
                              result?.result[0] == "E"
                            ? 1
                            : result?.result[0]
                        } ng-star-inserted`}
                      >
                        <a
                          _ngcontent-ng-c4176941694=""
                          data-bs-toggle="modal"
                          data-bs-target="#ballbyballResult"
                          className="number text-dark"
                        >
                          {result?.result[0]}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  _ngcontent-ng-c4176941694=""
                  id="ballbyballResult"
                  tabIndex={-1}
                  aria-labelledby="ballbyballResult"
                  aria-hidden="true"
                  className="modal fade"
                >
                  <div _ngcontent-ng-c4176941694="" className="modal-dialog">
                    <div _ngcontent-ng-c4176941694="" className="modal-content">
                      <div
                        _ngcontent-ng-c4176941694=""
                        className="modal-header bet-slip-head"
                      >
                        <h5
                          _ngcontent-ng-c4176941694=""
                          id="exampleModalLabel"
                          className="modal-title"
                        >
                          <b
                            _ngcontent-ng-c4176941694=""
                            style={{ textTransform: "capitalize" }}
                          ></b>
                        </h5>
                        <button
                          onClick={() => {
                            setSelectedResultToShow(null);
                          }}
                          _ngcontent-ng-c4176941694=""
                          type="button"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          className="close btn"
                        >
                          ×
                        </button>
                      </div>
                      <div
                        _ngcontent-ng-c4176941694=""
                        id="__BVID__33___BV_modal_body_"
                        className="modal-body"
                      >
                        <div
                          _ngcontent-ng-c4176941694=""
                          style={{ marginBottom: 20 }}
                        >
                          <div
                            _ngcontent-ng-c4176941694=""
                            className="modal-title p-2"
                          >
                            <h6
                              _ngcontent-ng-c4176941694=""
                              className="text-end round-id"
                            >
                              <b _ngcontent-ng-c4176941694="">
                                Round Id:{selectedResultToShow?.marketId}
                              </b>
                            </h6>
                          </div>
                          <div
                            _ngcontent-ng-c4176941694=""
                            className="col-12 paati_boxs"
                          >
                            {selectedResultToShow?.streamUrl?.split("}")[1] && (
                              <video
                                _ngcontent-ng-c2676723629=""
                                id="videoBallByball"
                                width="100%"
                                autoPlay
                                playsInline
                                muted
                                className="isDesktop ng-star-inserted"
                                style={{
                                  backgroundColor: "black",
                                  backgroundSize: "contain",
                                }}
                              >
                                <source
                                  _ngcontent-ng-c2676723629=""
                                  type="video/mp4"
                                  src={`https://uniique444.com${
                                    selectedResultToShow?.streamUrl?.split(
                                      "}"
                                    )[1]
                                  }`}
                                />{" "}
                                Your browser does not support the video tag.{" "}
                              </video>
                            )}
                          </div>
                          <div
                            _ngcontent-ng-c4176941694=""
                            className="clearfix"
                          />
                          <div
                            _ngcontent-ng-c4176941694=""
                            className="my-3 w-100 d-flex justify-content-center"
                          >
                            <span
                              _ngcontent-ng-c4176941694=""
                              className="bg-success pt-2 pb-2 ps-2 pe-2 text-white"
                              style={{ borderRadius: 3 }}
                            >
                              <b _ngcontent-ng-c4176941694="">
                                {selectedResultToShow?.result}{" "}
                              </b>
                              <i
                                _ngcontent-ng-c4176941694=""
                                className="fa fa-trophy winner-icon text-white"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </app-results>
              {/**/}
              {/**/}
            </div>
          </app-ballbyball>
        )}
        {/**/}
      </div>
      <div
        _ngcontent-ng-c2192290883=""
        className="sidebarright hideDekstop"
        style={{ width: "27vw" }}
      >
        <app-right-nav _ngcontent-ng-c2192290883="" _nghost-ng-c4093098567="">
          <div
            _ngcontent-ng-c4093098567=""
            style={{ width: "26.15vw", position: "fixed" }}
          >
            <div _ngcontent-ng-c4093098567="" className="card">
              {/**/}
              <div
                _ngcontent-ng-c4093098567=""
                id="live-Streaming"
                className="accordion-body"
              >
                {/**/}
              </div>
              <div _ngcontent-ng-c4093098567="" className="card-header">
                <strong
                  _ngcontent-ng-c4093098567=""
                  style={{ position: "relative", top: "0.5px" }}
                >
                  Open Bets
                </strong>
              </div>
              <div _ngcontent-ng-c4093098567="">
                <div
                  _ngcontent-ng-c4093098567=""
                  className="card-body open-bet-btns ng-star-inserted"
                >
                  <div
                    _ngcontent-ng-c4093098567=""
                    className="col-sm-12 p-0 mlist-openbets ng-star-inserted"
                  >
                    <select
                      _ngcontent-ng-c4093098567=""
                      id="eventNameSelect"
                      className="desktop-bets"
                    >
                      <option
                        _ngcontent-ng-c4093098567=""
                        value="undefined,undefined"
                        className="ng-star-inserted"
                      >
                        {" "}
                        Select Market
                      </option>
                      {/**/}
                    </select>
                    {/**/}
                  </div>
                  {/**/}
                </div>
                {/**/}
              </div>
            </div>
          </div>
        </app-right-nav>
      </div>
    </div>
  );
}
